<template>
	<div class="find-my-grind-label">
		<FindMyGrindQuiz />
	</div>
</template>

<script>
import FindMyGrindQuiz from '@/assets/the-find-my-grind-quiz.svg'

export default {
	name: "FindMyGrindLabel",
	components: {
		FindMyGrindQuiz
	}
}
</script>

<style lang="scss">
	.find-my-grind-label {
		max-width: 284px;
		margin-left: auto;
		margin-right: auto;
		padding: 2em 0;
		display: flex;
		justify-content: center;
		position: relative;
		z-index: map-get($z, 1);
		display: none;
		@include breakpoint(xlarge) {
			display: block;
		}
	}
</style>